(() => {
  const getHomeGuinnessUrl = () => {
    const root = window.routes?.root_url || '/';
    const separator = root.includes('?') ? '&' : '?';
    return `${root}${separator}view=home#ma-hawa-guinness-record`;
  };

  const cleanTechnicalInformation = (scope = document) => {
    scope.querySelectorAll('.ma-hawa-mineral-grid > div').forEach((row) => {
      const value = row.querySelector('dd');
      if (!value) return;
      const measurableValue = value.textContent
        .replace(/(?:mg|g)\s*\/\s*l/gi, '')
        .replace(/\s+/g, ' ')
        .trim();
      row.hidden = !/\d/.test(measurableValue);
    });

    scope.querySelectorAll('.ma-hawa-mineral-composition').forEach((section) => {
      const visibleRows = Array.from(section.querySelectorAll('.ma-hawa-mineral-grid > div')).filter((row) => !row.hidden);
      section.hidden = visibleRows.length === 0;
    });

    scope.querySelectorAll('.ma-hawa-product-technical [data-technical-row]').forEach((row) => {
      const value = row.querySelector('[data-technical-value]');
      if (!value) return;
      row.hidden = value.textContent.trim() === '';
    });
  };

  const normalizeGuinnessLinks = (scope = document) => {
    const internalUrl = getHomeGuinnessUrl();
    scope.querySelectorAll(
      '[data-mh-guinness-header-link], .mh-guinness-bar__link, .mh-gwr-footer__link, [data-mh-guinness-certificate-link]'
    ).forEach((link) => {
      link.href = internalUrl;
      link.removeAttribute('target');
      link.removeAttribute('rel');
      link.setAttribute(
        'aria-label',
        document.documentElement.lang.toLowerCase().startsWith('ar')
          ? 'عرض قسم غينيس للأرقام القياسية في الصفحة الرئيسية'
          : 'View the Guinness World Records section on the home page'
      );
    });
  };

  const initialize = (scope = document) => {
    cleanTechnicalInformation(scope);
    normalizeGuinnessLinks(scope);
  };

  const schedule = () => [0, 120, 450, 1100].forEach((delay) => window.setTimeout(() => initialize(), delay));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('change', (event) => {
    if (event.target.closest('variant-selects, variant-radios, .product-form')) schedule();
  }, true);
})();
